module.exports = __webpack_public_path__ + "img/call.75037cc3.svg";